import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatErr(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function fmtNGN(n) {
  if (n == null) return "₦0";
  return "₦" + Number(n).toLocaleString("en-NG", { maximumFractionDigits: 0 });
}

export function fmtUSD(n) {
  if (n == null) return "$0";
  return "$" + Number(n).toLocaleString("en-US", { maximumFractionDigits: 2 });
}

export function fmtBps(bps) {
  return `${(Number(bps) / 100).toFixed(2)}%`;
}

export function fmtDate(s) {
  if (!s) return "—";
  try {
    const d = new Date(s);
    return d.toLocaleDateString("en-NG", { year: "numeric", month: "short", day: "numeric" });
  } catch {
    return s;
  }
}
